export const UseCases = {
  RESOURCE_LISTING_MAIN: 'Main',
  RESOURCE_LISTING_AR: 'Analyst Reports',
  RESOURCE_LISTING_WP: 'White Papers',
  RESOURCE_LISTING_CS: 'Case Studies',
  RESOURCE_LISTING_WEBINAR: 'Webinars',
  RESOURCE_LISTING_VIDEO: 'Videos',
  RESOURCE_LISTING_BROCHURE: 'Brochures',
  RESOURCE_LISTING_EVENTS: 'Events',
  GRID_LEFT_ALIGNED: 'Items left-aligned',
  GRID_RIGHT_ALIGNED: 'Items right-aligned',
  GRID_CENTERED: 'Items centered',
}

export const HERO_USECASES = {
  MINIMAL: 'Minimal',
  PRODUCT_HERO: 'Product Hero',
  CENTERED_WITH_DOTS: 'Centered text with dots',
  FULL_WIDTH_HERO: 'Full width hero',
}

export const PAGE_TYPES = {
  EVENTS: 'events',
  FLEX: 'flex',
  FORM_FLEX: 'formFlex',
  PARTNERS: 'partners',
  WEBINAR_RECORDING: 'webinarRecording',
  SOLUTIONS: 'solutions',
  PRODUCT: 'product',
  ABOUT_RPA: 'aboutRPA',
  THANK_YOU: 'thankYou',
  COMPANY_LISTING: 'companyListing',
  RESOURCE_LISTING: 'resourceListing',
  LEGAL: 'legal',
  RAWHTML: 'rawHTML',
}

export const MENU_STYLES = {
  TABS: 'Tabs',
}

export const SPONSOR_USECASES = {
  DIAMOND: 'Diamond',
  RUBY: 'Ruby',
  EMERALD: 'Emerald',
  SAPPHIRE: 'Sapphire',
}
